export function getCookie(cname: string): string | null {
  const nameEQ = `${cname}=`;
  const ca = document.cookie.split(';');
  /* eslint-disable */
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  /* eslint-enable */
  return null;
}

export function setCookie(
  cname: string,
  cvalue: string,
  exdays?: number | undefined,
  domain?: string | undefined,
  samesite?: boolean | undefined
) {
  const secure = window.location.hostname !== 'localhost';
  const d = new Date();
  let expires = null;

  if (exdays !== undefined) {
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    if (exdays.constructor === Number) {
      expires = exdays === Infinity ? 'expires=Fri, 31 Dec 9999 23:59:59 GMT' : `expires=${d.toUTCString()}`;
    }
  }

  document.cookie =
    `${cname}=${cvalue};` +
    (expires ? `${expires};` : '') +
    (domain ? `domain=${domain};path=/;` : '') +
    (samesite ? `SameSite=${samesite};` : '') +
    (secure ? 'Secure;' : '');
}
